import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/** Purple tint for the two teams in this match. */
export const MATCH_TABLE_HIGHLIGHT = 'rgba(167,139,250,0.10)';

const STAT_CELL_WIDTH = 23;

export function getMatchHubStandingsTableStyles(theme: Theme) {
  return StyleSheet.create({
    card: {
      backgroundColor: theme.background.card,
      borderRadius: theme.borderRadius.xl,
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
      marginBottom: theme.spacing.md,
    },
    headRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingBottom: theme.spacing.sm,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 9,
      borderRadius: 8,
    },
    rowHighlighted: {
      backgroundColor: MATCH_TABLE_HIGHLIGHT,
    },
    headPos: {
      width: 20,
      fontSize: 10.5,
      fontWeight: '700',
      color: theme.gray[400],
      textAlign: 'center',
    },
    headTeam: {
      flex: 1,
      paddingLeft: 6,
      fontSize: 10.5,
      fontWeight: '700',
      color: theme.gray[400],
      textAlign: 'left',
    },
    headCell: {
      width: STAT_CELL_WIDTH,
      fontSize: 10.5,
      fontWeight: '700',
      color: theme.gray[400],
      textAlign: 'center',
    },
    pos: {
      width: 20,
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[500],
      textAlign: 'center',
    },
    team: {
      flex: 1,
      minWidth: 0,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 7,
      paddingLeft: 4,
    },
    teamName: {
      flexShrink: 1,
      fontSize: 12.5,
      fontWeight: '600',
      color: theme.gray[900],
    },
    statCell: {
      width: STAT_CELL_WIDTH,
      fontSize: 12,
      color: theme.gray[600],
      textAlign: 'center',
      fontVariant: ['tabular-nums'],
    },
    ptsCell: {
      width: STAT_CELL_WIDTH,
      fontSize: 13,
      fontWeight: '800',
      color: theme.gray[900],
      textAlign: 'center',
      fontVariant: ['tabular-nums'],
    },
  });
}
